"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPAction = void 0;
var OTPAction;
(function (OTPAction) {
    OTPAction["SetPassword"] = "SET_PASSWORD";
    OTPAction["ResetPassword"] = "RESET_PASSWORD";
})(OTPAction = exports.OTPAction || (exports.OTPAction = {}));
//# sourceMappingURL=AuthRequests.js.map